<template>
  <b-badge
    v-if="show"
    v-b-tooltip.hover
    variant="warning"
    :title="tip"
  >
    {{ $t('ledger_close_late') }}
  </b-badge>
</template>

<script>
import { BBadge, VBTooltip } from 'bootstrap-vue'

export default {
  name: 'LatePostingBadge',
  components: { BBadge },
  directives: { 'b-tooltip': VBTooltip },
  props: {
    late: { type: Boolean, default: false },
    lateFromDate: { type: String, default: '' },
  },
  computed: {
    show() {
      return this.late
    },
    tip() {
      return this.$t('ledger_close_late_tip', { date: this.lateFromDate || '—' })
    },
  },
}
</script>
